const elemHD = document.querySelectorAll('.wt_HotelDescription');
window.fireOnVisible(elemHD, async () => {
    await import('./assets/css/hotel_description.scss');
});
